export default __webpack_public_path__ + "static/media/magnifying-glass-icon.9bbd06c5.svg";